// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"user_wrapper__I1YEU","avatar":"user_avatar__ZJek4","avatarEdit":"user_avatarEdit__fuUT2"};